import { render, staticRenderFns } from "./Gl.vue?vue&type=template&id=6244fa95&scoped=true&"
import script from "./Gl.vue?vue&type=script&lang=js&"
export * from "./Gl.vue?vue&type=script&lang=js&"
import style0 from "./Gl.vue?vue&type=style&index=0&id=6244fa95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244fa95",
  null
  
)

export default component.exports